import { render, staticRenderFns } from "./partner-equ.vue?vue&type=template&id=245ad9ed&scoped=true&"
import script from "./partner-equ.vue?vue&type=script&lang=js&"
export * from "./partner-equ.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "245ad9ed",
  null
  
)

export default component.exports